import type React from 'react';
import SessionMeta from '../atoms/SessionMeta';

export interface SessionFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  date: string;
  messageCount: number;
  customMeta?: React.ReactNode;
}

export default function SessionFooter({
  date,
  messageCount,
  customMeta,
  className = '',
  ...props
}: SessionFooterProps) {
  return (
    <div className={`flex items-center justify-between mt-2 ${className}`} {...props}>
      <SessionMeta variant="date">
        {date}
      </SessionMeta>
      <div className="flex items-center space-x-2">
        {customMeta}
        <SessionMeta variant="count">
          {messageCount} msg{messageCount !== 1 ? 's' : ''}
        </SessionMeta>
      </div>
    </div>
  );
}